import React from 'react';
import Header from '../components/Header';
import HeroSection from '../components/HeroSection';
import ServicesSection from '../components/ServicesSection';
import AboutSection from '../components/AboutSection';
import GlobalReachSection from '../components/GlobalReachSection';
import ProjectsSection from '../components/ProjectsSection';
import BlogSection from '../components/BlogSection';
import ContactSection from '../components/ContactSection';
import Footer from '../components/Footer';
import SEO from '../components/SEO';
import { useTranslation } from '../hooks/useTranslation';

const HomePage = () => {
  const { t } = useTranslation();
  
  return (
    <div className="min-h-screen">
      <SEO 
        title="Xiamen Tower Technology - Import & Export Solutions from China"
        description="Your trusted partner for import-export and product sourcing from China. We specialize in connecting international businesses with reliable Chinese manufacturers, ensuring quality, efficiency, and seamless supply chain management."
        keywords="import from china, export china, product sourcing, chinese manufacturers, import export, xiamen tower technology, china sourcing, quality control china, manufacturing china, supply chain management"
      />
      <Header />
      <HeroSection />
      <ServicesSection />
      <AboutSection />
      <GlobalReachSection />
      <ProjectsSection />
      <BlogSection />
      <ContactSection />
      <Footer />
    </div>
  );
};

export default HomePage;